import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import Login from './login';
import Main from '../Main';

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <Main>
      <Login />
    </Main>
  </StrictMode>
);
